import { CalendarOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation/initYup.ts';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { getDynamicWidgetReference } from '../../../../expressions/references/builder/getDynamicWidgetReference.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { createCommonFormSchema } from '../../inputs/common/createCommonFormSchema.ts';
import { DefaultWidgetDateFormat } from '../../inputs/date/IDateWidget.ts';
import { type IComputedDateWidget } from '../IComputedWidget.ts';
import { ComputedDateConfigComponent } from './ComputedDateConfigComponent.tsx';
import { ComputedDateWidgetComponent } from './ComputedDateWidgetComponent.tsx';
import { ComputedDateWidgetPreview } from './ComputedDateWidgetPreview.tsx';
import { computedDateConfigSchema } from './computedDateConfigSchema.ts';
import { setComputedDateTransform } from './setComputedDateTransform.ts';

export const ComputedDateWidgetType: IWidgetType<IComputedDateWidget> = {
  type: WidgetType.ComputedDate,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Computed,
  hasValue: true,
  getReference: getDynamicWidgetReference(Datatype.Date),
  name: 'Data Calcolata',
  icon: <CalendarOutlined />,
  rules: [],
  formComponent: ComputedDateWidgetComponent,
  createFormSchema: ({ widget, parentScope }) => {
    return createCommonFormSchema(
      setComputedDateTransform(
        widget,
        parentScope,
        yup
          .string()
          .stringDate(DefaultWidgetDateFormat.serializeFormat)
          .notRequired(),
      ),
      widget,
    );
  },
  configComponent: ComputedDateConfigComponent,
  configValidator: computedDateConfigSchema,
  previewComponent: ComputedDateWidgetPreview,
  translationSchema: tran.widget({
    label: tran.rte(),
  }),
  alwaysEnabled: true,
};
